import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardList,
  faChartBar,
  faGuitar,
  faDollarSign,
  faUsers,
  faFilter,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory, NavLink, useLocation } from "react-router-dom";
import AdminDiv from "../AdminDiv";

const SideBar = ({ handleShowFilterBar, showFilterBar }) => {
  const history = useHistory();
  const location = useLocation();
  const chosen =
    "mt-7 pt-3 px-3 grid justify-items-center text-white bg-blue-500";
  const notChosen = "mt-7 pt-3 px-3 grid justify-items-center hover:text-white";

  return (
    <div className="h-screen bg-gray-800 w-24">
      <div className="grid justify-items-center">
        <div className="text-gray-300 grid">
          <NavLink to="/home/">
            <p className="text-2xl text-white font-semibold mt-5 -mb-3 text-center">
              TM
            </p>
          </NavLink>
          {location.pathname.includes("sales/events/") ? (
            <button
              onClick={() => history.push("sales/events")}
              className={notChosen}
            >
              <FontAwesomeIcon icon={faArrowLeft} className="text-2xl" />
              <p className="text-xs mt-2 pb-2 tracking-wide">FILTER</p>
            </button>
          ) : (
            <button
              onClick={handleShowFilterBar}
              disabled={showFilterBar}
              className={showFilterBar ? chosen : notChosen}
            >
              <FontAwesomeIcon icon={faFilter} className="text-2xl" />
              <p className="text-xs mt-2 pb-2 tracking-wide">FILTER</p>
            </button>
          )}
          <NavLink
            to="/inventory"
            activeClassName={chosen}
            className={notChosen}
          >
            <FontAwesomeIcon icon={faClipboardList} className="text-2xl" />
            <p className="text-xs mt-2 pb-2">INVENTORY</p>
          </NavLink>
          <NavLink
            to="/sales"
            activeClassName={chosen}
            className={notChosen}
          >
            <FontAwesomeIcon icon={faDollarSign} className="text-xl" />
            <p className="text-xs mt-2 pb-2">SALES</p>
          </NavLink>
          <NavLink to="/reports" activeClassName={chosen} className={notChosen}>
            <FontAwesomeIcon icon={faChartBar} className="text-2xl" />
            <p className="text-xs mt-2 pb-2">REPORTS</p>
          </NavLink>
          <NavLink to="/artists" activeClassName={chosen} className={notChosen}>
            <FontAwesomeIcon icon={faGuitar} className="text-xl" />
            <p className="text-xs mt-2 pb-2">ARTISTS</p>
          </NavLink>
          <AdminDiv>
            <NavLink to="/users" activeClassName={chosen} className={notChosen}>
              <FontAwesomeIcon icon={faUsers} className="text-xl" />
              <p className="text-xs mt-2 pb-2">USERS</p>
            </NavLink>
          </AdminDiv>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
